import { ProductoService } from '@/services/ProductoService'
export default ({
  namespaced: true,
  state: {
    merchantId_local: process.env.VUE_APP_MERCHANT_ID_LOCAL,
    merchantId_ext: process.env.VUE_APP_MERCHANT_ID_EXT,
    productos: [],
    selectedCurrency: 'ext',
    subTotalCompraLocal: 0,
    subTotalCompraExt: 0,
    totalCompraLocal: 0,
    totalCompraExt: 0,
    totalIgvLocal: 0,
    totalIgvExt: 0,
    despacho: {
      partnerCisco: '',
      opcionActiva: 'retiro',
      datosAlmacen: {
        opcionEntrega: '',
        contactoDespacho: '',
        personalComprador: {
          nombre: '',
          tipoDocumento: '',
          numeroDocumento: '',
          telefono: ''
        },
        agenciaTransporte: {
          razonSocial: '',
          ruc: '',
          nombre: ''
        }
      },
      cupon: '',
      datosDelivery: {
        direccion: '',
        opcionEntrega: '',
        nombre: '',
        tipoDocumento: '',
        numeroDocumento: '',
        telefono: '',
        empresaTransporte: '',
        direccionAgencia: '',
        opcionDespacho: ''
      }
    },
    pago: {
      estado: 'failed',
      opcionActiva: 'tarjeta',
      aceptoTerminos: true,
      lineaCredito: []
    },
    costoEnvio: 0,
    costoEnvioLocal: 0,
    cotizaTercero: false,
    agenteRetencion: 'no',
    totalAgenteRetencionLocal: 0,
    totalAgenteRetencionExt: 0,
    totalCompraAgenteRetencionExt: 0,
    totalCompraAgenteRetencionLocal: 0,
    productosSinStock: []
  },
  mutations: {
    agregarProducto (state, producto) {
      const item = state.productos.find(p => p.producto.codigo === producto.producto.codigo)
      if (item) {
        item.cantidad += producto.cantidad
        item.producto.totalLocal = parseFloat((item.producto.precio_local_sin_igv * item.cantidad).toFixed(2))
        item.producto.totalExt = parseFloat((item.producto.precio_ext_sin_igv * item.cantidad).toFixed(2))

        if (item.producto.estado_producto === 'transito') {
          const codigoInterno = producto.producto.codigo_interno
          if (!item.productos_orden_transito) {
            item.productos_orden_transito = {}
          }
          if (item.productos_orden_transito[codigoInterno]) {
            item.productos_orden_transito[codigoInterno].cantidad += producto.cantidad
          } else {
            item.productos_orden_transito[codigoInterno] = {
              cantidad: producto.cantidad,
              stock: producto.producto.stock,
              coddoc: producto.producto.coddoc,
              numdoc: producto.producto.numdoc,
              almacen: producto.producto.almacen,
              numite: producto.producto.numite,
              fecProyTran: producto.producto.fecProyTran
            }
          }
        }
      } else {
        producto.cantidad = producto.cantidad || 1
        producto.producto.totalLocal = parseFloat((producto.producto.precio_local_sin_igv * producto.cantidad).toFixed(2))
        producto.producto.totalExt = parseFloat((producto.producto.precio_ext_sin_igv * producto.cantidad).toFixed(2))

        if (producto.producto.estado_producto === 'transito') {
          const codigoInterno = producto.producto.codigo_interno
          if (!producto.productos_orden_transito) {
            producto.productos_orden_transito = {}
          }
          producto.productos_orden_transito[codigoInterno] = {
            cantidad: producto.cantidad,
            stock: producto.producto.stock,
            coddoc: producto.producto.coddoc,
            numdoc: producto.producto.numdoc,
            almacen: producto.producto.almacen,
            numite: producto.producto.numite,
            fecProyTran: producto.producto.fecProyTran
          }
        }

        const productoClonado = { ...producto }
        if (Object.prototype.hasOwnProperty.call(productoClonado.producto, 'especificaciones')) {
          delete productoClonado.producto.especificaciones
        }
        if (Object.prototype.hasOwnProperty.call(productoClonado.producto, 'producto_transito')) {
          delete productoClonado.producto.producto_transito
        }
        if (Object.prototype.hasOwnProperty.call(productoClonado.producto, 'producto_carrete')) {
          delete productoClonado.producto.producto_carrete
        }
        if (Object.prototype.hasOwnProperty.call(productoClonado.producto, 'ficha')) {
          delete productoClonado.producto.ficha
        }
        console.log(productoClonado.producto)
        state.productos.push(productoClonado)
      }
    },
    actualizarProducto (state, producto) {
      const item = state.productos.find(p => p.producto.codigo === producto.producto.codigo)
      if (item) {
        item.cantidad = producto.cantidad
        item.producto.totalLocal = parseFloat((item.producto.precio_local_sin_igv * item.cantidad).toFixed(2))
        item.producto.totalExt = parseFloat((item.producto.precio_ext_sin_igv * item.cantidad).toFixed(2))
      }
    },
    quitarProducto (state, producto) {
      state.productos = state.productos.filter(p => p.producto.codigo !== producto.producto.codigo)
    },
    vaciarCarrito (state) {
      state.productos = []
      state.subTotalCompraLocal = 0
      state.subTotalCompraExt = 0
      state.totalCompraLocal = 0
      state.totalCompraExt = 0
      state.totalIgvLocal = 0
      state.totalIgvExt = 0
      state.despacho = {
        partnerCisco: '',
        opcionActiva: 'retiro',
        datosAlmacen: {
          opcionEntrega: '',
          contactoDespacho: '',
          personalComprador: {
            nombre: '',
            tipoDocumento: '',
            numeroDocumento: '',
            telefono: ''
          },
          agenciaTransporte: {
            razonSocial: '',
            ruc: '',
            nombre: ''
          }
        },
        cupon: '',
        datosDelivery: {
          direccion: '',
          opcionEntrega: '',
          nombre: '',
          tipoDocumento: '',
          numeroDocumento: '',
          telefono: '',
          empresaTransporte: '',
          direccionAgencia: '',
          opcionDespacho: ''
        }
      }
      state.pago = {
        estado: 'completed',
        opcionActiva: 'tarjeta',
        aceptoTerminos: true
      }
      state.costoEnvio = 0
      state.costoEnvioLocal = 0
      state.cotizaTercero = false
      state.agenteRetencion = 'no'
      state.totalAgenteRetencionLocal = 0
      state.totalAgenteRetencionExt = 0
      state.totalCompraAgenteRetencionExt = 0
      state.totalCompraAgenteRetencionLocal = 0
      state.productosSinStock = []
    },
    setCurrency (state, selectedCurrency) {
      state.selectedCurrency = selectedCurrency
    },
    setTotales (state) {
      state.subTotalCompraLocal = 0
      state.subTotalCompraExt = 0
      state.totalIgvExt = 0
      state.totalIgvLocal = 0

      state.productos.forEach(prod => {
        state.subTotalCompraLocal += parseFloat(prod.producto.totalLocal)
        state.subTotalCompraExt += parseFloat(prod.producto.totalExt)
      })

      state.totalIgvExt = parseFloat(((state.subTotalCompraExt + state.costoEnvio) * 0.18).toFixed(2))
      state.totalIgvLocal = parseFloat(((state.subTotalCompraLocal + state.costoEnvioLocal) * 0.18).toFixed(2))

      const calcularCotizacion = (state.subTotalCompraLocal + state.totalIgvLocal) / (state.subTotalCompraExt + state.totalIgvExt)
      state.costoEnvioLocal = parseFloat((state.costoEnvio * calcularCotizacion).toFixed(2))
      state.totalCompraExt = parseFloat((state.subTotalCompraExt + state.totalIgvExt + state.costoEnvio).toFixed(2))
      state.totalCompraLocal = parseFloat((state.subTotalCompraLocal + state.totalIgvLocal + state.costoEnvioLocal).toFixed(2))
      state.subTotalCompraLocal = parseFloat((state.subTotalCompraLocal).toFixed(2))
      state.subTotalCompraExt = parseFloat((state.subTotalCompraExt).toFixed(2))

      if (state.agenteRetencion === 'si') {
        state.totalAgenteRetencionLocal = parseFloat(((state.totalCompraLocal) * 0.03).toFixed(2))
        state.totalAgenteRetencionExt = parseFloat(((state.totalCompraExt) * 0.03).toFixed(2))
        state.totalCompraAgenteRetencionExt = parseFloat((state.totalCompraExt - state.totalAgenteRetencionExt).toFixed(2))
        state.totalCompraAgenteRetencionLocal = parseFloat((state.totalCompraLocal - state.totalAgenteRetencionLocal).toFixed(2))
      }
    },
    setDespachoDetalle (state, payload) {
      state.despacho.partnerCisco = payload
    },
    setDespachoDeliveryRetiro (state, payload) {
      state.despacho = payload
    },
    setPagoSeguro (state, payload) {
      state.pago = payload
    },
    setPagoEstado (state, status) {
      state.pago.estado = status
    },
    setMerchantId (state) {
      state.merchantId_local = process.env.VUE_APP_MERCHANT_ID_LOCAL
      state.merchantId_ext = process.env.VUE_APP_MERCHANT_ID_EXT
    },
    setCostoEnvio (state, payload) {
      state.costoEnvio = payload.costoEnvio
      state.costoEnvioLocal = 0
      state.cotizaTercero = payload.cotizaTercero
    },
    setAgenteRetencion (state, agent) {
      state.agenteRetencion = agent
    },
    setProductosSinStock (state, productos) {
      state.productosSinStock = productos
    }
  },
  actions: {
    async agregarProducto ({ commit }, producto) {
      await commit('agregarProducto', producto)
      commit('setTotales')
    },
    async quitarProducto ({ commit }, producto) {
      await commit('quitarProducto', producto)
      commit('setTotales')
    },
    async actualizarProducto ({ commit }, producto) {
      await commit('actualizarProducto', producto)
      commit('setTotales')
    },
    async vaciarCarrito ({ commit }) {
      await commit('vaciarCarrito')
      commit('setTotales')
    },
    cambiarMoneda ({ commit }, selectedCurrency) {
      commit('setCurrency', selectedCurrency)
    },
    verificarProductoEnCarrito ({ state }, producto) {
      return state.productos.some(p => p.producto.codigo === producto.codigo)
    },
    setDespachoDetalle ({ commit }, payload) {
      commit('setDespachoDetalle', payload)
    },
    setDespachoDeliveryRetiro ({ commit }, payload) {
      commit('setDespachoDeliveryRetiro', payload)
    },
    setPagoSeguro ({ commit }, payload) {
      commit('setPagoSeguro', payload)
    },
    setMerchantId ({ commit }) {
      commit('setMerchantId')
    },
    async generarOrden2 ({ commit, state }, paymentData) {
      try {
        const generarOrden = new ProductoService()
        const combinedData = { ...state, paymentData: { ...paymentData } }
        await generarOrden.generarOrden(combinedData)
          .then(response => {
            if (response.error === true) {
              commit('setPagoEstado', 'failed')
            } else {
              commit('setPagoEstado', 'completed')
              commit('vaciarCarrito')
              const setCostoEnvio = { costoEnvio: 0, cotizaTercero: false, costoEnvioLocal: 0 }
              commit('setCostoEnvio', setCostoEnvio)
            }
          }).catch(error => {
            commit('setPagoEstado', 'failed')
            console.error('catch', error)
          })
      } catch (error) {
        console.error('Error completing order:', error)
        commit('setPagoEstado', 'failed')
      }
    },
    async generarOrden ({ commit, state }, paymentData) {
      try {
        const productoService = new ProductoService()
        const combinedData = { ...state, paymentData: { ...paymentData } }
        const response = await productoService.generarOrden(combinedData)

        if (response.error === true) {
          commit('setPagoEstado', 'failed')
        } else {
          commit('setPagoEstado', 'completed')
          commit('vaciarCarrito')
          const setCostoEnvio = { costoEnvio: 0, cotizaTercero: false, costoEnvioLocal: 0 }
          commit('setCostoEnvio', setCostoEnvio)
        }
        return response
      } catch (error) {
        commit('setPagoEstado', 'failed')
        return { error: true, mensaje: error.mensaje || 'Error al generar la orden', orden: error.orden }
      }
    },
    async validarStock ({ state }) {
      try {
        const productoService = new ProductoService()
        const response = await productoService.validarStock({ productos: state.productos })
        return response
      } catch (error) {
        return { error: true, mensaje: error.mensaje || 'Error al generar la orden' }
      }
    },
    async setCostoEnvio ({ commit }, payload) {
      await commit('setCostoEnvio', payload)
      commit('setTotales')
    },
    async setAgenteRetencion ({ commit }, payload) {
      await commit('setAgenteRetencion', payload)
      commit('setTotales')
    },
    async setProductosSinStock ({ commit }, payload) {
      await commit('setProductosSinStock', payload)
    }
  }
})
